"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeWrapper = void 0;
var React = _interopRequireWildcard(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _utils = require("../../utils");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _dateRangePicker = require("../../utils/date-range-picker");
var _qa = require("../../utils/qa");
var _Button = require("../Button");
var _Card = require("../Card");
var _Calendar = require("./Calendar");
var _Dropdown = require("../Dropdown");
var _FocusManager = require("../FocusManager");
var _Icon = require("../Icon");
var _Text = require("../Text");
var _DateRangeWrapperModule = _interopRequireDefault(require("./DateRangeWrapper.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CalendarHeader = _ref => {
  let {
    t,
    date,
    marker,
    minDate,
    maxDate,
    setMonth,
    rangeStartMonth,
    rangeEndMonth,
    onClickNext,
    nextDisabled,
    prevDisabled,
    onClickPrevious,
    testId
  } = _ref;
  const availableYears = (0, _utils.generateAvailableYears)({
    marker,
    minDate,
    maxDate,
    rangeStartMonth,
    rangeEndMonth
  });
  const availableMonths = (0, _utils.getAvailableMonths)({
    marker,
    minDate,
    maxDate,
    rangeStartMonth,
    rangeEndMonth,
    t
  });
  const MONTHS = (0, _utils.getMonths)(t);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _DateRangeWrapperModule.default.calendarHeader,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: `header-${marker}`
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ClickableIcon, {
      ariaLabel: (0, _dateRangePicker.getTranslation)(t, 'Select Previous Month'),
      size: "small",
      name: "chevron-left",
      className: (0, _classify.default)(_DateRangeWrapperModule.default.headerIcon, {
        [_DateRangeWrapperModule.default.disabledIcon]: prevDisabled
      }),
      onClick: () => !prevDisabled && onClickPrevious(),
      color: prevDisabled ? 'disabled' : 'secondary',
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: `prev-button-${marker}`
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Dropdown, {
      size: "small",
      disabled: !availableMonths.length || (0, _dateRangePicker.isAfter)(minDate, maxDate),
      menu: {
        selectedKeys: [_moment.default.utc(date).month().toString()],
        options: availableMonths
      },
      onChange: event => {
        setMonth((0, _utils.getMonthEndDate)(_moment.default.utc(date).set('M', Number(event.key))));
      },
      dropdownInputText: MONTHS[_moment.default.utc(date).month()].label,
      scrollMenuToBottom: true,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: `month-dropdown-${marker}`
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Dropdown, {
      disabled: !availableYears.length || (0, _dateRangePicker.isAfter)(minDate, maxDate),
      menu: {
        selectedKeys: [_moment.default.utc(date).year().toString()],
        options: availableYears
      },
      size: "small",
      onChange: event => {
        setMonth((0, _utils.getMonthEndDate)(_moment.default.utc(date).set('y', Number(event.key))));
      },
      dropdownInputText: _moment.default.utc(date).year().toString(),
      scrollMenuToBottom: true,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: `year-dropdown-${marker}`
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.ClickableIcon, {
      size: "small",
      ariaLabel: (0, _dateRangePicker.getTranslation)(t, 'Select Next Month'),
      name: "chevron-right",
      className: (0, _classify.default)(_DateRangeWrapperModule.default.headerIcon, {
        [_DateRangeWrapperModule.default.disabledIcon]: nextDisabled
      }),
      onClick: () => !nextDisabled && onClickNext(),
      color: nextDisabled ? 'disabled' : 'secondary',
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: `next-button-${marker}`
      })
    })]
  });
};
const DateRangeWrapper = exports.DateRangeWrapper = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    onApply,
    onCancel,
    handlers,
    hoverDay,
    minDate,
    maxDate,
    timezone,
    dateRange,
    rangeStartMonth,
    setTimezone,
    rangeEndMonth,
    inHoverRange,
    setRangeStartMonth,
    setRangeEndMonth,
    cardWrapperClass,
    hideTimezone,
    today,
    startDateLabel,
    endDateLabel,
    t,
    locale,
    testId
  } = _ref2;
  const canNavigateCloser = _moment.default.utc(rangeStartMonth).year() !== _moment.default.utc(rangeEndMonth).year() || Math.abs(_moment.default.utc(rangeStartMonth).month() - _moment.default.utc(rangeEndMonth).month()) > 1;
  const handleApplyClick = () => {
    const {
      startDate,
      endDate
    } = dateRange;
    const startDateUTC = startDate && (0, _dateRangePicker.addTimezoneStartOfDay)(startDate, timezone);
    const endDateUTC = endDate && (0, _dateRangePicker.addTimezoneEndOfDay)(endDate, timezone);
    onApply({
      startDate,
      endDate,
      startDateUTC,
      endDateUTC,
      timezone
    });
  };
  const {
    onMonthNavigate
  } = handlers;
  const commonProps = {
    inHoverRange,
    handlers,
    hoverDay,
    dateRange,
    minDate,
    maxDate,
    today,
    t,
    testId
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FocusManager.FocusManager, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card, {
      classNames: {
        wrapper: (0, _classify.default)(_DateRangeWrapperModule.default.dateRangeWrapper, cardWrapperClass)
      },
      ref: ref,
      testId: (0, _qa.generateTestId)({
        base: testId,
        slot: 'card'
      }),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.CardHeader, {
        className: _DateRangeWrapperModule.default.cardHeader,
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'header'
        }),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.BodySmall, {
          className: _DateRangeWrapperModule.default.selectedDate,
          color: _Text.TEXT_COLORS.secondary,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'start-date-label'
          }),
          children: `${startDateLabel || (0, _dateRangePicker.getTranslation)(t, 'Start Date')}: ${(0, _dateRangePicker.getFormattedDate)(_utils.MARKERS.DATE_RANGE_START, dateRange, locale)}`
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
          name: "minus",
          size: _Icon.ICON_SIZE.small,
          type: _Icon.ICON_TYPE.regular,
          color: _Text.TEXT_COLORS.secondary,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'separator-icon'
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.BodySmall, {
          className: _DateRangeWrapperModule.default.selectedDate,
          color: _Text.TEXT_COLORS.secondary,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'end-date-label'
          }),
          children: `${endDateLabel || (0, _dateRangePicker.getTranslation)(t, 'End Date')}: ${(0, _dateRangePicker.getFormattedDate)(_utils.MARKERS.DATE_RANGE_END, dateRange, locale)}`
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: _DateRangeWrapperModule.default.calendarMenuContainer,
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'calendar-menu-container'
        }),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CalendarHeader, {
          t: t,
          marker: _utils.MARKERS.DATE_RANGE_START,
          rangeStartMonth: rangeStartMonth,
          rangeEndMonth: rangeEndMonth,
          date: rangeStartMonth,
          setMonth: setRangeStartMonth,
          nextDisabled: !canNavigateCloser,
          prevDisabled: (0, _dateRangePicker.isSameOrBefore)(rangeStartMonth, minDate, 'month'),
          minDate: minDate,
          maxDate: maxDate,
          onClickNext: () => onMonthNavigate(_utils.MARKERS.DATE_RANGE_START, _utils.NAVIGATION_ACTION.NEXT),
          onClickPrevious: () => onMonthNavigate(_utils.MARKERS.DATE_RANGE_START, _utils.NAVIGATION_ACTION.PREV),
          testId: testId
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(CalendarHeader, {
          t: t,
          marker: _utils.MARKERS.DATE_RANGE_END,
          rangeStartMonth: rangeStartMonth,
          rangeEndMonth: rangeEndMonth,
          date: rangeEndMonth,
          setMonth: setRangeEndMonth,
          nextDisabled: (0, _dateRangePicker.isSameOrAfter)(rangeEndMonth, maxDate, 'month'),
          prevDisabled: !canNavigateCloser,
          minDate: minDate,
          maxDate: maxDate,
          onClickNext: () => onMonthNavigate(_utils.MARKERS.DATE_RANGE_END, _utils.NAVIGATION_ACTION.NEXT),
          onClickPrevious: () => onMonthNavigate(_utils.MARKERS.DATE_RANGE_END, _utils.NAVIGATION_ACTION.PREV),
          testId: testId
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.CardContent, {
        className: _DateRangeWrapperModule.default.dateRangeCalendars,
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'calendars'
        }),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.Calendar, {
          marker: _utils.MARKERS.DATE_RANGE_START,
          value: rangeStartMonth,
          ...commonProps,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'start-calendar'
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: _DateRangeWrapperModule.default.divider,
          "data-testid": (0, _qa.generateTestId)({
            base: testId,
            slot: 'divider'
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.Calendar, {
          marker: _utils.MARKERS.DATE_RANGE_END,
          value: rangeEndMonth,
          ...commonProps,
          testId: (0, _qa.generateTestId)({
            base: testId,
            slot: 'end-calendar'
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.CardFooter, {
        className: _DateRangeWrapperModule.default.cardFooter,
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'footer'
        }),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.CardTitle, {
          className: _DateRangeWrapperModule.default.timezoneDropdownContainer,
          "data-testid": (0, _qa.generateTestId)({
            base: testId,
            slot: 'timezone-container'
          }),
          children: !hideTimezone && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dropdown.Dropdown, {
            menu: {
              selectedKeys: [timezone],
              options: (0, _utils.getTimezones)(t),
              allowSearch: true,
              virtualization: {
                enable: true
              },
              staticLabels: {
                SEARCH_PLACEHOLDER: `${(0, _dateRangePicker.getTranslation)(t, 'Search')}...`,
                RESULT: (0, _dateRangePicker.getTranslation)(t, 'result'),
                RESULTS: (0, _dateRangePicker.getTranslation)(t, 'results')
              }
            },
            dropdownInputText: (0, _dateRangePicker.getTranslation)(t, _dateRangePicker.TIMEZONES[timezone]),
            disabled: (0, _dateRangePicker.isAfter)(minDate, maxDate),
            classNames: {
              box: _DateRangeWrapperModule.default.timezoneDropdown
            },
            onChange: event => setTimezone(event.key),
            size: "small",
            testId: (0, _qa.generateTestId)({
              base: testId,
              slot: 'timezone-dropdown'
            })
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.CardActions, {
          "data-testid": (0, _qa.generateTestId)({
            base: testId,
            slot: 'actions'
          }),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            type: "ghost",
            onClick: onCancel,
            size: "small",
            testId: (0, _qa.generateTestId)({
              base: testId,
              slot: 'cancel-button'
            }),
            children: (0, _dateRangePicker.getTranslation)(t, 'Cancel')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            onClick: handleApplyClick,
            size: "small",
            disabled: !(dateRange.startDate && dateRange.endDate),
            testId: (0, _qa.generateTestId)({
              base: testId,
              slot: 'apply-button'
            }),
            children: (0, _dateRangePicker.getTranslation)(t, 'Apply')
          })]
        })]
      })]
    })
  });
});